<template>
  <v-sheet elevation="2">
    <v-tabs v-model="selectedTab" slider-size="4" slider-color="blue">
      <v-tab
        class="px-15"
        active-class="grey--text text--darken-4 px-15"
        data-tourid="routine-details-executions"
      >
        {{ $t('routines.executions') }}
      </v-tab>
      <v-tab
        class="px-15"
        active-class="grey--text text--darken-4 px-15"
        data-tourid="routine-details-findings"
      >
        {{ $t('assignments.finding_other') }}
      </v-tab>
    </v-tabs>

    <v-divider />

    <div v-show="selectedTab === TABS.EXECUTIONS">
      <RoutineExecutions
        :routineDefinition="routineDefinition"
        :loading="loadingExecutions"
        :executions="executions"
        :totalExecutions="totalExecutions"
        @getRoutineExecutions="$emit('getRoutineExecutions', $event)"
      />
    </div>
    <div v-show="selectedTab === TABS.FINDINGS">
      <RoutineFindings
        :routineDefinition="routineDefinition"
        :loading="loadingFindings"
        :findings="findings"
        :totalFindings="totalFindings"
        @getRoutineFindings="$emit('getRoutineFindings', $event)"
      />
    </div>
  </v-sheet>
</template>

<script>
import RoutineFindings from './RoutineFindings.vue'
import RoutineExecutions from './RoutineExecutions.vue'

import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

const TABS = {
  FINDINGS: 1,
  EXECUTIONS: 0,
}
export default {
  name: 'RoutineDetailsTable',

  mixins: [trackerMixin],

  components: {
    RoutineFindings,
    RoutineExecutions,
  },

  props: {
    loadingExecutions: Boolean,
    loadingFindings: Boolean,
    executions: Array,
    findings: Array,
    routineDefinition: Object,
    totalExecutions: { type: Number, String },
    totalFindings: { type: Number, String },
  },

  data() {
    return {
      TABS,
      selectedTab: TABS.EXECUTIONS,
      isRoutineDefinitionLoading: false,
    }
  },

  watch: {
    selectedTab(value) {
      this.trackRoutineDetailsTable({
        action: 'changeTab',
        tab: Object.keys(TABS)[value],
      })
    },
  },
}
</script>
